__webpack_require__.p = "https://ai-music.github.io/webdaw/";